/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ContactInfo } from './ContactInfo';
import type { PublicBookingSiteAddress } from './PublicBookingSiteAddress';
import type { PublicBookingSiteCategory } from './PublicBookingSiteCategory';
import type { PublicBookingSiteTheme } from './PublicBookingSiteTheme';
import type { TherapistCharacteristic } from './TherapistCharacteristic';
export type PublicBookingSite = {
    publicId: string;
    title: string | null;
    layout: PublicBookingSite.layout;
    showAddress: boolean;
    requireEmailConfirmation: boolean;
    therapistUUID: string;
    therapistName: string;
    therapistTitle: string | null;
    therapistFirstName: string | null;
    therapistLastName: string | null;
    therapistImage: string | null;
    therapistDescription: string | null;
    cityName: string | null;
    therapistAddress: PublicBookingSiteAddress | null;
    bookingNote: string | null;
    updatedAt: string;
    categories: Array<PublicBookingSiteCategory>;
    theme: PublicBookingSiteTheme | null;
    logoUrl: string | null;
    logoDarkUrl: string | null;
    characteristics: Array<TherapistCharacteristic>;
    contactInfos: Array<ContactInfo>;
};
export namespace PublicBookingSite {
    export enum layout {
        COMPACT = 'compact',
        EXTENDED = 'extended',
    }
}

